export const HSA = 'league_spending_hsa';
export const LSA = 'league_spending_lsa';
